import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-estes-improvement',
  templateUrl: './estes-improvement.component.html',
  styleUrls: ['./estes-improvement.component.sass']
})
export class EstesImprovementComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    document.querySelector(".__page-root").scrollIntoView(true);
  }

}
